var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tfrSignUpsDashboard"},[_vm._m(0),_c('div',{staticClass:"tfrSignUpsDashboard__button"},[_c('span',{staticClass:"text",on:{"click":_vm.exportToExcel}},[_vm._v("Export")])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tfrSignUpsDashboard__header"},[_c('div',{staticClass:"tfrSignUpsDashboard__title"},[_vm._v("The FLY Report Sign Ups")])])
}]

export { render, staticRenderFns }